class PriceRangeSlider {
  constructor(container) {
    this.container = container;

    this.minRange = container.querySelector('[data-price-range-min]');
    this.maxRange = container.querySelector('[data-price-range-max]');

    this.minInput = container.querySelector('[data-price-input-min]');
    this.maxInput = container.querySelector('[data-price-input-max]');

    this.progress = container.querySelector(
      '[data-price-slider-progress]'
    );

    this.minDisplay = container.querySelector(
      '[data-price-min-display]'
    );

    this.maxDisplay = container.querySelector(
      '[data-price-max-display]'
    );

    if (
      !this.minRange ||
      !this.maxRange ||
      !this.minInput ||
      !this.maxInput ||
      !this.progress
    ) {
      return;
    }

    this.min = Number(this.minRange.min);
    this.max = Number(this.maxRange.max);

    this.bindEvents();
    this.updateSlider();
  }

  bindEvents() {
    // Raise whichever thumb the user grabs above the other, so overlapping
    // handles near the same value are both reliably draggable.
    this.minRange.addEventListener('pointerdown', () => {
      this.minRange.style.zIndex = '3';
      this.maxRange.style.zIndex = '2';
    });

    this.maxRange.addEventListener('pointerdown', () => {
      this.maxRange.style.zIndex = '3';
      this.minRange.style.zIndex = '2';
    });

    this.minRange.addEventListener('input', () => {
      let min = Number(this.minRange.value);
      const max = Number(this.maxRange.value);

      if (min >= max) {
        min = Math.max(this.min, max - 1);
        this.minRange.value = min;
      }

      this.minInput.value = this.formatInputValue(min);

      this.updateSlider();
    });

    this.minRange.addEventListener('change', () => {
      this.applyFilter();
    });

    this.maxRange.addEventListener('input', () => {
      const min = Number(this.minRange.value);
      let max = Number(this.maxRange.value);

      if (max <= min) {
        max = Math.min(this.max, min + 1);
        this.maxRange.value = max;
      }

      this.maxInput.value = this.formatInputValue(max);

      this.updateSlider();
    });

    this.maxRange.addEventListener('change', () => {
      this.applyFilter();
    });


    this.minInput.addEventListener('input', () => {
      let value = this.parseValue(this.minInput.value);

      if (Number.isNaN(value)) {
        value = this.min;
      }

      value = Math.max(
        this.min,
        Math.min(
          value,
          Number(this.maxRange.value) - 1
        )
      );

      this.minRange.value = value;

      this.updateSlider();
    });

    this.minInput.addEventListener('change', () => {
      this.applyFilter();
    });

    this.maxInput.addEventListener('input', () => {
      let value = this.parseValue(this.maxInput.value);

      if (Number.isNaN(value)) {
        value = this.max;
      }

      value = Math.min(
        this.max,
        Math.max(
          value,
          Number(this.minRange.value) + 1
        )
      );

      this.maxRange.value = value;

      this.updateSlider();
    });

    this.maxInput.addEventListener('change', () => {
      this.applyFilter();
    });
  }


  applyFilter() {
    const min = Number(this.minRange.value);
    const max = Number(this.maxRange.value);

    this.minInput.value = this.formatInputValue(min);
    this.maxInput.value = this.formatInputValue(max);

    this.minInput.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );

    this.maxInput.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  updateSlider() {
    const min = Number(this.minRange.min);
    const max = Number(this.minRange.max);

    const minValue = Number(this.minRange.value);
    const maxValue = Number(this.maxRange.value);

    const range = max - min;

    if (range <= 0) {
      return;
    }

    const left =
      ((minValue - min) / range) * 100;

    const right =
      100 -
      ((maxValue - min) / range) * 100;

    this.progress.style.left = `${left}%`;
    this.progress.style.right = `${right}%`;

    this.updateDisplays(
      minValue,
      maxValue
    );
  }

  updateDisplays(min, max) {
    if (this.minDisplay) {
      this.minDisplay.textContent =
        this.formatMoney(min);
    }

    if (this.maxDisplay) {
      this.maxDisplay.textContent =
        this.formatMoney(max);
    }
  }

  parseValue(value) {
    if (!value) {
      return NaN;
    }

    return Number(
      String(value)
        .replace(/,/g, '')
        .replace(/[^\d.-]/g, '')
    );
  }

  // Two decimal places, matching the format the price text inputs and the
  // theme's money parser expect (e.g. "125.00" rather than "125"), so the
  // dispatched change event resolves to the correct filter value.
  formatInputValue(value) {
    return Number(value).toFixed(2);
  }


  formatMoney(value) {
    const currency =
      this.container.dataset.currency ||
      document.documentElement.dataset.currency ||
      'USD';

    try {
      return new Intl.NumberFormat(
        undefined,
        {
          style: 'currency',
          currency: currency,
          maximumFractionDigits: 0
        }
      ).format(value);

    } catch (error) {
      return value;
    }
  }
}

function initPriceRangeSliders() {
  document
    .querySelectorAll('[data-price-slider]')
    .forEach((slider) => {

      if (
        slider.dataset.priceSliderInitialized === 'true'
      ) {
        return;
      }

      slider.dataset.priceSliderInitialized = 'true';

      new PriceRangeSlider(slider);
    });
}

if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    initPriceRangeSliders
  );

} else {

  initPriceRangeSliders();

}

document.addEventListener(
  'shopify:section:load',
  initPriceRangeSliders
);

document.addEventListener(
  'shopify:section:reorder',
  initPriceRangeSliders
);